import React, {useState} from 'react'
import {CardActionArea, CardMedia, Grid, Typography} from "@material-ui/core";
import style from './menugrid.module.css'
import get from 'lodash/get'
import FileDownloadGrid from "../../pages/home/filedownloadgrid";
function MenuGrid (props){
    const {list}  =props;
    const [customFuncClick,setCustomFuncClick] = useState(false);
    const [methodTrigger,setMethodTrigger] = useState(false);
    return (
        <Grid container className={style.grid_container} onclick={(e)=>{e.preventDefault()}}>
                <Grid className={style.grid_inner_container}>
                    { list.map((item,index)=>{
                        const customFunc = get(item,"customFunc");
                        return <Grid container className={style.grid_card_parent_container}>
                            <CardActionArea onClick={(e)=>{
                                console.log("customFunc clicked on the action")
                                e.preventDefault()
                                const link = get(item,"link");
                                if(customFunc){
                                    customFunc()
                                }else{
                                    window.location.href= link()
                                }
                              }}>


                            <Grid item className={style.grid_card_container}>
                                    <CardMedia
                                        component="img"
                                        image={get(item,"img")}
                                        alt="CardMedia Image Example"
                                        height="180"
                                        title=""
                                    />

                            </Grid>

                            <Grid item className={style.grid_card_title_container}>
                                <Typography>
                                    {get(item,"title")}
                                </Typography>

                            </Grid>
                            </CardActionArea>
                        </Grid>


                    })
                            }
                </Grid>
        </Grid>



    )
}

export default MenuGrid